import type { ReactElement } from 'react';

import { AppliedSOLRFacet } from './AppliedSOLRFacet';
import type { SelectedFacetV2 } from '~/utilities/graphql/codegen';

type AppliedSOLRFacetsProps = {
  className?: string;
  facets: SelectedFacetV2[];
  visibleFiltersCount: number;
};

export const AppliedSOLRFacets = ({
  className,
  facets,
  visibleFiltersCount,
}: AppliedSOLRFacetsProps): ReactElement => (
  <>
    {facets.map((facet, index) => {
      const isHidden = index >= visibleFiltersCount;

      return (
        <li key={facet.code} className={className} data-hidden={isHidden} aria-hidden={isHidden}>
          <AppliedSOLRFacet facet={facet} />
        </li>
      );
    })}
  </>
);
